import {
  planChangeResultSchema,
  resourceUsageReportSchema,
  subscriptionSummarySchema,
  type ChangePlanInput,
  type PlanChangeResult,
  type ResourceUsageReport,
  type SubscriptionSummary,
} from '@tailoring-crm/shared';
import type { ApiClient } from '../api/client.js';

/** The billing screen's two calls. Neither takes money — task 24 owns the gateway. */

const SUBSCRIPTION = '/subscription';

export async function getSubscription(client: ApiClient): Promise<SubscriptionSummary> {
  return await client.get(SUBSCRIPTION, { schema: subscriptionSummarySchema });
}

/**
 * The meters alone.
 *
 * A separate call from {@link getSubscription} rather than a field off it, because the two are
 * read at different rhythms and by different roles: the fat billing response is the owner's
 * and needs `billing.read`, while this one is on `settings.read` so a manager standing in
 * front of a nearly-full catalogue can see that they are.
 */
export async function getResourceUsage(client: ApiClient): Promise<ResourceUsageReport> {
  return await client.get(`${SUBSCRIPTION}/usage`, { schema: resourceUsageReportSchema });
}

export async function changePlan(
  client: ApiClient,
  input: ChangePlanInput,
): Promise<PlanChangeResult> {
  return await client.post(`${SUBSCRIPTION}/plan`, input, { schema: planChangeResultSchema });
}
